<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'DownloadMultipleFiles',
  props: {
    requestIds: { type: [Object, Array], default: null },
    module: { type: [String], default: null },
  },
  data() {
    return {
      requestIdsC: this.requestIds,
      moduleC: this.module,
      loadingData: false,
      modalErrorShow: false,
      modalError: '',
      dataUrl: '',
      failed_requests: [],
    }
  },
  computed: {},
  created() {
    this.loadingData = true
    this.modalErrorShow = false
    if (this.requestIds.length === 0) {
      this.$toastr.e('Error: No requests selected')
      return
    } else {
      this.fetchData()
    }
  },
  mounted() {},
  methods: {
    fetchData() {
      axiosGetPost(
        'post',
        'requests/downloadMultipleFiles',
        { request_ids: this.requestIds, module: this.module.toLowerCase() },
        'Download Multiple File Requests, owner client ' +
          this.module.toUpperCase()
      ).then((response) => {
        let data = response
        if (data.success === true) {
          this.showErrors(data)
          this.createDownloadElement(data)
          this.loadingData = false
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }
        return data
      })
    },
    createDownloadElement(data) {
      this.dataUrl = data.url
      var link = document.createElement('a')
      link.setAttribute('target', '_blank')
      link.href = this.dataUrl
      link.click()
      URL.revokeObjectURL(link.href)
    },
    showErrors(data) {
      if (data.failed_requests) {
        this.modalErrorShow = true
        this.modalError =
          'Error To download IDs: ' + data.failed_requests.join(', ')
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="form-group row">
      <div class="col-md-12">
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>
        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted" style="color: red;">{{ modalError }}</h6>
            </div>
          </div>
        </div>
        <div v-if="dataUrl" class="col text-center">
          <p>
            Download Multiple Files. If the download doesn't start
            automatically, please
            <a :href="dataUrl"> <strong>click here</strong>.</a></p
          >
        </div>
      </div>
    </div>
  </div>
</template>
